import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DialogContent, styled } from "@mui/material";

export const StyledDialogContent = styled(DialogContent)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  "& audio": {
    height: "35px",
    "&::-webkit-media-controls-enclosure": {
      borderRadius: "5px",
    },
  },
});

export const RecordingHint = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.error.main,
  "@keyframes pulsate": {
    from: {
      opacity: 1,
      transform: "scale(1)",
    },
    to: {
      opacity: 0,
      transform: "scale(1.5)",
    },
  },
  animation: "pulsate 1s infinite ease",
}));
